import React from 'react';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { FileRepresenting } from '../../../../../../model/asset';
import { FormImageUpload } from '../../../../../../components/Form/FileUpload/FormImageUpload';
import { t } from '../../../../../../locales/translate';
import { Button } from '../../../../../../components/Button/Button';
import { handleError } from '../../../../../../model/notification';
import { updateEventImage } from '../../../../../../model/event';
import { SubmitLine } from '../../../../../../components/SubmitLine/SubmitLine';

interface Props {
  product: {
    id: string;
    image?: FileRepresenting | null;
  };
  onClose: () => void;
}

export function EventImageModal({ product, onClose }: Props): JSX.Element {
  const { fields, onSubmit, submissionStatus, changes, dirty, valid } = useForm({
    model: product,
    onSubmitError: handleError,
    onSubmit: async () => {
      await updateEventImage({ eventId: product.id, image: changes.image });
      onClose();
    },
  });
  return (
    <form>
      <FormImageUpload {...fields.image} />
      <SubmitLine>
        <Button title={t.actions.cancel('')} onClick={() => onClose()} />
        <Button
          title={t.actions.save('')}
          type="primary"
          loading={submissionStatus === 'submitting'}
          disabled={!(dirty && valid)}
          onClick={onSubmit}
        />
      </SubmitLine>
    </form>
  );
}
